import { useState, useEffect } from "react";
import { Keyboard } from "@capacitor/keyboard";
import { isNativeApp } from "@/models/platform";

export function useKeyboard() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const configureKeyboardListener = async () => {
      if (!isNativeApp()) return;

      const showListener = await Keyboard.addListener(
        "keyboardWillShow",
        () => {
          setIsVisible(true);
        }
      );

      // Add a didShow listener to catch cases where keyboard is already visible on mount
      const didShowListener = await Keyboard.addListener(
        "keyboardDidShow",
        () => {
          setIsVisible(true);
        }
      );

      const hideListener = await Keyboard.addListener("keyboardDidHide", () => {
        const timeoutId = setTimeout(() => {
          setIsVisible(false);
        }, 100);
        return () => clearTimeout(timeoutId);
      });

      return () => {
        showListener.remove();
        didShowListener.remove();
        hideListener.remove();
      };
    };

    configureKeyboardListener();
  }, []);

  return {
    isVisible,
  };
}

export default useKeyboard;
